import {CssBaseline} from '@mui/material';
import {useAuthContext} from '@/auth';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import Router from '@/router';
import ThemeProvider from '@/theme/ThemeProvider';
import {isManagementViewEnabled} from "@/utilities/EnvironmentUtility";
import UserActions from "@/stores/actions/userActions";
import InitBackendActions from '@/stores/actions/initBackendActions';
import MetadataActions from '@/stores/actions/metadataActions';
import ProductActions from '@/stores/actions/productActions';
import EntitlementActions from '@/stores/actions/entitlementActions';
import WidgetActions from '@/stores/actions/widgetsAction';


function App() {
    const authContext = useAuthContext();
    const dispatch = useDispatch();

    useEffect(() => {
    const idToken = localStorage.getItem("id_token");
        if(authContext.isAuthenticated && idToken && idToken != '') {
            if(isManagementViewEnabled()) {
                dispatch(UserActions.updateOwnUser(idToken));
                //dispatch(UserActions.getUserList());
                //dispatch(UserActions.getUserAdminList());
                //dispatch(ProductActions.getProductList());
                //dispatch(MetadataActions.getMetadata());
                //dispatch(MetadataActions.getMetadataRelations());
                //dispatch(EntitlementActions.getEntitlementList());
                //dispatch(WidgetActions.getWidgetList());
            }
            
        }
    }, [authContext.isAuthenticated]);

    useEffect(() => {
        dispatch(InitBackendActions.getInit());
        authContext.initAuth();
    }, [dispatch]);

    return (
    <ThemeProvider>
        <BrowserRouter>
            <CssBaseline/>
            <Router/>
        </BrowserRouter>
    </ThemeProvider>
    );
}

export default App;
